// extracted by mini-css-extract-plugin
export default {"root":"AmountStrip_root__mItMq","value":"AmountStrip_value__n-rWz"};